import { createAction } from '@reduxjs/toolkit'
import { DeeplinkFlowType } from '@/deeplink/types'

export const captureDeeplink = createAction<Record<string, string>>('deeplink/captureDeeplink')
export const clearFlow = createAction<DeeplinkFlowType>('deeplink/clearFlow')
